'use client';

import {
  Divider,
  MantineProvider,
  Modal,
  // eslint-disable-next-line import/named
  VariantColorsResolver,
  createTheme,
  defaultVariantColorsResolver
} from '@mantine/core';
import { Notifications } from '@mantine/notifications';

const theme = createTheme({
  defaultRadius: 'md',
  components: {
    Divider: Divider.extend({
      styles: {
        root: {
          borderColor: '#DDDDDD'
        }
      }
    }),
    Modal: Modal.extend({
      defaultProps: {
        radius: 'lg',
        overlayProps: {
          backgroundOpacity: 0.1,
          blur: 3
        }
      }
    })
  }
});

const variantColorResolver: VariantColorsResolver = (input) => {
  const defaultResolvedColors = defaultVariantColorsResolver(input);

  // Add new variants support
  if (input.variant === 'danger') {
    return {
      background: 'var(--mantine-color-red-9)',
      hover: 'var(--mantine-color-red-8)',
      color: 'var(--mantine-color-white)',
      border: 'none'
    };
  }

  return defaultResolvedColors;
};

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <MantineProvider
      theme={{
        primaryColor: 'darkGrayTheme',
        colors: {
          darkGrayTheme: [
            '#f1f5f9',
            '#e2e8f0',
            '#cbd5e1',
            '#94a3b8',
            '#64748b',
            '#475569',
            '#334155',
            '#1e293b',
            '#0f172a',
            '#020617'
          ],

          bwTheme: [
            '#e7e7e7',
            '#d1d1d1',
            '#b0b0b0',
            '#888888',
            '#6d6d6d',
            '#5d5d5d',
            '#3d3d3d',
            '#222222',
            '#111111',
            '#000000'
          ]
        },
        primaryShade: 7,
        ...theme,
        variantColorResolver
      }}
    >
      <Notifications position="top-right" />
      {children}
    </MantineProvider>
  );
}
